export default __webpack_public_path__ + "static/carolin-e1585576101970-356e6ddbaa0a347891c38004e1f2cd72.jpg";